// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { initialModulationValues } from '../../helpers'
import { castToString } from 'helpers/reduxFormFunctions'

// returns modulation details data. This will either be the matching modulation
// data that comes from redux store for previously saved modulations
// or it will be the initial modulation details data because we're creating a new modulation.

// NOTE - radioModulationId will either be an actual id from the DB or it will
// be a temporary id because a modulation was created and added to redux-store
// but the radio has not yet been saved. In this type of a scenario,
// the fake id will be of the following pattern: `temp-modulation-id-${Date.now()}`
// See formatModulationData.js for where this is created.

const getRadioModulationData = radioModulationId => (dispatch, getState) => {
  const modulationDetailsFromState = (
    getState()
      .databaseDetails.getIn(['initialValues', 'radioModulations'])
      .find(d => castToString(d.get('radioModulationId')) === radioModulationId)
  )

  const modulationDataIsFromState = modulationDetailsFromState !== undefined

  const modulationData = (
    modulationDataIsFromState
      ? modulationDetailsFromState.toJS()
      : { ...initialModulationValues }
  )

  return {
    modulationData,
    modulationDataIsFromState,
  }
}

export default getRadioModulationData
